import React from 'react';
import { ListChecks } from 'lucide-react';

const ListsMockup: React.FC = () => {
  return (
    <div className="bg-gray-50 rounded-2xl p-5 h-[380px] flex flex-col shadow-lg">
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-xl font-bold text-gray-800">AI Experts</h3>
        <div className="flex items-center gap-2">
          <button className="h-8 px-3 rounded-full text-xs font-medium bg-white text-gray-700 border border-gray-300 shadow-sm flex items-center gap-1">
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
            Add Item
          </button>
        </div>
      </div>

      {/* List Content */}
      <div className="flex-1 overflow-y-auto pr-2">
        <div className="space-y-3">
          {/* List Item 1 */}
          <div className="flex items-center p-3 bg-white rounded-lg border border-gray-200 shadow-sm">
            <div className="flex-shrink-0 mr-3">
              <div className="h-9 w-9 bg-blue-100 rounded-full flex items-center justify-center">
                <span className="text-blue-600 font-medium text-sm">GH</span>
              </div>
            </div>
            <div className="flex-1 flex items-center">
              <p className="text-sm text-gray-800 font-medium">Geoffrey Hinton</p>
            </div>
          </div>

          {/* List Item 2 */}
          <div className="flex items-center p-3 bg-white rounded-lg border border-gray-200 shadow-sm">
            <div className="flex-shrink-0 mr-3">
              <div className="h-9 w-9 bg-purple-100 rounded-full flex items-center justify-center">
                <span className="text-purple-600 font-medium text-sm">YB</span>
              </div>
            </div>
            <div className="flex-1 flex items-center">
              <p className="text-sm text-gray-800 font-medium">Yoshua Bengio</p>
            </div>
          </div>

          {/* List Item 3 */}
          <div className="flex items-center p-3 bg-white rounded-lg border border-gray-200 shadow-sm">
            <div className="flex-shrink-0 mr-3">
              <div className="h-9 w-9 bg-green-100 rounded-full flex items-center justify-center">
                <span className="text-green-600 font-medium text-sm">AL</span>
              </div>
            </div>
            <div className="flex-1 flex items-center">
              <p className="text-sm text-gray-800 font-medium">Andrew Ng</p>
            </div>
          </div>

          {/* List Item 4 */}
          <div className="flex items-center p-3 bg-white rounded-lg border border-gray-200 shadow-sm">
            <div className="flex-shrink-0 mr-3">
              <div className="h-9 w-9 bg-orange-100 rounded-full flex items-center justify-center">
                <span className="text-orange-600 font-medium text-sm">FB</span>
              </div>
            </div>
            <div className="flex-1 flex items-center">
              <p className="text-sm text-gray-800 font-medium">Fei-Fei Li</p>
            </div>
          </div>

          {/* List Item 5 */}
          <div className="flex items-center p-3 bg-white rounded-lg border border-gray-200 shadow-sm">
            <div className="flex-shrink-0 mr-3">
              <div className="h-9 w-9 bg-red-100 rounded-full flex items-center justify-center">
                <span className="text-red-600 font-medium text-sm">IL</span>
              </div>
            </div>
            <div className="flex-1 flex items-center">
              <p className="text-sm text-gray-800 font-medium">Ian LeCun</p>
            </div>
          </div>

          {/* List Item 6 */}
          <div className="flex items-center p-3 bg-white rounded-lg border border-gray-200 shadow-sm">
            <div className="flex-shrink-0 mr-3">
              <div className="h-9 w-9 bg-pink-100 rounded-full flex items-center justify-center">
                <span className="text-pink-600 font-medium text-sm">DH</span>
              </div>
            </div>
            <div className="flex-1 flex items-center">
              <p className="text-sm text-gray-800 font-medium">Demis Hassabis</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const listsMockupData = {
  type: 'Lists',
  icon: ListChecks,
  description:
    'Create simple lists for shopping, to-dos, or any items you need to track. Add, check off, and organize items quickly to keep on top of everything that matters.',
  mockup: <ListsMockup />,
};

export default ListsMockup;
